import React from 'react';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { InputNumberComponent } from '../../../../../components/prime-formik';

const SuperProfileMinimumOverallQAndRScoreRequired = () => {
  return (
    <div className="p-col-12">
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.minimum-overall-q-and-r-score-required"
          defaultMessage="Minimum overall Q&R score required"
        >
          {(text) => (
            <label className="field-label" htmlFor="minimumOverallQAndRScoreRequired">
              {text}
            </label>
          )}
        </FormattedMessage>
        <div className="p-inputgroup right">
          <Field
            id="minimumOverallQAndRScoreRequired"
            name="minimumOverallQAndRScoreRequired"
            className="width-full"
            component={InputNumberComponent}
          />
          <span className="p-inputgroup-addon">%</span>
        </div>
      </div>
    </div>
  );
};

export default SuperProfileMinimumOverallQAndRScoreRequired;
